<template>
  <div class="orderContent">
    <a-radio-group
      v-model:value="submitParams.confirmed"
      style="margin-bottom: 20px"
      name="radioGroup"
    >
      <a-radio :value="false">修改复诊日期</a-radio>
      <a-radio :value="true" v-if="selectPushMap?.reserveState === 5">帮助患者确认复诊日期</a-radio>
    </a-radio-group>
    <div v-if="submitParams.confirmed === false" class="remind">
      请分别与医生、患者确认时间再填写
    </div>
    <RetreatForm
      ref="reFormRef"
      v-if="submitParams.confirmed === false"
      :ucPatientId="props.ucPatientId"
      :ucDoctorId="props.ucDoctorId"
    />
  </div>
</template>

<script setup>
import { ref, reactive, defineExpose, defineProps } from 'vue'
import RetreatForm from './retreatForm.vue'
const props = defineProps({
  ucPatientId: { type: String },
  ucDoctorId: { type: String },
  selectPushMap: {
    type: Object,
    default: () => ({})
  }
})
const submitParams = reactive({
  confirmed: false
})
const mainformValid = () => {
  return new Promise((resolve, reject) => {
    if (submitParams.confirmed === null) {
      reject()
    }
    resolve(submitParams)
  })
}
const reFormRef = ref()
const submitForm = () => {
  if (!reFormRef.value) return {}
  return reFormRef.value.submitValidQuery()
}

defineExpose({
  submitForm,
  mainformValid
})
</script>
<style lang="scss" scoped>
@import './normalizeOrder.scss';
</style>
